<template>
  <v-autocomplete
    dense
    class="rounded-lg"
    :outlined="outline"
    ref="autoRef"
    v-model="model"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    clearable
    hide-details
    :item-text="itemTextAuto"
    :item-value="itemValue"
    :label="label"
    :filter="filterRemoteItems"
    prepend-icon="mdi-database-search"
    :color="color"
    @change="handleChange"
    @click:clear="borradoContenido"
    :key="keyAuto"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Buscar
          <strong>{{textoBusqueda}}</strong>
        </v-list-item-title>
      </v-list-item>
    </template>

    <template v-slot:append >
      <v-icon
        color="green"
        @keyup.enter="searchAdvance(model)"
        @click="searchAdvance(model)"
      > mdi-send-circle </v-icon>
    </template>

  </v-autocomplete>
</template>

<script>
import { paginationMethods } from "../mixins/pagination"; 
export default {
  mixins: [paginationMethods],
  props:{
    outline:{
      type: Boolean,
      required: false,
      default: false
    },
    textoBusqueda:{
      type: String,
      required: true
    },
    fieldName:{
      type: String,
      required: true
    },
    label:{
      type: String,
      required: true
    },
    color:{
      type: String,
      required: false,
      default: "green"
    },
    itemText:{
      type: Array,
      required: true
    },
    itemValue:{
      type: String,
      required: true
    },
    advanceSearchFields:{
      type: Object,
      required: false,
      default: {}
    },
    rutaItemAuto:{
      type: String,
      required: true
    },
    procesoCompleto:{
      type: Boolean,
      required: false,
      default: false
    },
    modoEdicion:{
      type: Boolean,
      required: true,
      default: false
    },
    itemEditar:{
      required: false
    },
    alternativeRutaItemAuto:{
      required: false
    }
  },
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    search: null,
    tab: null,
    itemSelected: false,
    keyAuto:0,
    procesoInterno: false,
    globalUrl:'',
    _searchTimer: null,
    _searchRequestId: 0
  }),
  watch: {
    modoEdicion(val){
      if (val){
        this.searchAdvance(true)
      }
    },
    procesoCompleto(val){
      this.keyAuto++
      if (val){
        this.isLoading = false
        this.items = []
        this.model = null
        this.search = null
        this.tab = null
        this.itemSelected = false
        this.procesoInterno = false
      }
    },
    search(val) {
      if(val && val.length > 2 && !this.itemSelected && !this.procesoInterno){
        this.clearSearchTimer()
        const term = val
        this.emitSearchText(term)
        this._searchTimer = setTimeout(() => {
          this.items = []
          this.searchAdvance(false, term)
        }, 400)
      } else if (val && this.itemSelected && !this.procesoInterno) {
        this.clearSearchTimer()
        this.itemSelected = false
      } else {
        this.clearSearchTimer()
        this.emitSearchText(null)
      }
    },
    alternativeRutaItemAuto(val){
      if (val){
        this.globalUrl = val + `${this.itemEditar.id}`
      }
    },
    model(val){
      console.log(val)
    }
  },
  methods:{
    clearSearchTimer(){
      if (this._searchTimer) {
        clearTimeout(this._searchTimer)
        this._searchTimer = null
      }
    },
    normalizeSearchTerm(term){
      return term === null || term === undefined ? '' : String(term).trim()
    },
    normalizeResultItems(result){
      if (Array.isArray(result)) return result
      if (Array.isArray(result?.data)) return result.data
      if (Array.isArray(result?.results)) return result.results
      return result ? [result] : []
    },
    filterRemoteItems(){
      return true
    },
    emitSearchText(term){
      const searchTerm = this.normalizeSearchTerm(term)
      this.$emit('search-text', { searchTerm, label: this.fieldName })
    },
    borradoContenido(){
      this.clearSearchTimer()
      this.itemSelected = false
      this.keyAuto++
      this.items = []
      this.model = null
      this.tab = null
      this.search = null
      this.globalUrl = this.rutaItemAuto + this.itemEditar ? this.itemEditar.id : ''
      this.emitSearchText(null)
      
    },
    async searchAdvance(id=false, expectedSearch=null){
      console.log('buscando valores')
      // console.log(this.search)
      if(!id){
        const searchTerm = this.normalizeSearchTerm(expectedSearch || this.search)
        if (searchTerm && searchTerm.length > 2){
          this.isLoading = true;
    
          let fields = {...this.advanceSearchFields}
          for (let propiedad in fields) {
            if (fields.hasOwnProperty(propiedad)) {
                fields[propiedad] = searchTerm; // Aquí colocamos la busqueda del auto
            }
          }
          const query = new URLSearchParams(fields)
          await this.$store.dispatch('AuthModule/verifyToken')
          try {
            const result = await this.$store.dispatch('fechData', {
              token: this.$store.state.AuthModule.accessToken,
              method: 'GET',
              url: `${this.rutaItemAuto}?${query.toString()}`,
              body: {},
              params: null
            })
            const resultItems = this.normalizeResultItems(result).map(item => ({ ...item }))
            this.items = resultItems
            this.emitSearchText(searchTerm)
            this.$nextTick(() => {
              if (this.$refs.autoRef && this.items.length > 0) {
                this.$refs.autoRef.isMenuActive = true
              }
            })
          } catch (err) {
            this.errorAlert(err)
          } finally {
            this.isLoading = false
          }
          // this.$refs.autoRef.focus()
  
        }
      } else if (id){

        if (!this.globalUrl && !this.alternativeRutaItemAuto){
          this.globalUrl = this.itemEditar ? this.itemEditar.id : ''
        } else if(this.alternativeRutaItemAuto){
          this.globalUrl = this.alternativeRutaItemAuto + `${this.itemEditar.id}`
        }


        let url = this.globalUrl
        let fields = {}
        fields.id = this.itemEditar
        const query = new URLSearchParams(fields)
          // Lazily load input items
          await this.getDataGeneral(
            "GET",
            url,
            'items',
            "isLoading",
            {},
            false, //paginacion
            false, // opcion para que devuelva algo
            false, //modo normal activado, vienen todos los resultados
            null, //parametros de ruta
            true, //busqueda un solo registro
          )
          this.procesoInterno = true
          this.keyAuto++

          if (this.items.length == 1){
            this.model = this.items[0].id
          }
      } else {
        console.error('NO SE QUE HACER')
      }
    },
    itemTextAuto(item){
      if (!item || typeof item !== 'object') return item ? String(item) : ''
      let resultado = '';
      for (const elemento of this.itemText) {
        
        if (elemento == 'neto_pagar') {
          let numero = this.$convertToMoney(item[elemento])
          resultado += `$${numero} `;
        } else if (elemento == 'tonelada'){
          let tonelada = parseInt(item[elemento])
          resultado += `${tonelada} `
        } else {
          resultado += `${item[elemento]} `;
        }
      }
      return resultado
    },
    handleChange(item){
      this.clearSearchTimer()
      console.log('escogi redultado', this.items, item)
      this.itemSelected = true
      const itemSelected = this.items.find(destino => destino.id == item)
      // console.warn('change inside auto', itemSelected)
      this.$emit('change-auto', {itemSelected, label:this.fieldName})
    }
  },
  beforeDestroy() {
    this.clearSearchTimer()
    this._searchRequestId++
    // this.procesoCompleto = false
    this.isLoading = false
    this.items = []
    this.model = null
    this.search = null
    this.tab = null
    this.itemSelected = false
    this.procesoInterno = false
  },
};
</script>

<style></style>
